import { getIconOption, generalIconOptions, socialIconOptions, type IconSet } from "@/components/icons/iconRegistry";
import { IconRenderer } from "@/components/icons/IconRenderer";

const optionsBySet = {
  general: generalIconOptions,
  social: socialIconOptions,
};

export function IconSelect({
  label = "Icon",
  value,
  onChange,
  iconSet = "general",
}: {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  iconSet?: IconSet;
}) {
  const options = optionsBySet[iconSet];
  const selected = getIconOption(value, iconSet);

  return (
    <label className="block">
      <span className="text-sm text-content-secondary">{label}</span>
      <div className="mt-2 grid grid-cols-[3rem_1fr] gap-2">
        <span className="grid h-11 place-items-center rounded-md border border-cyan-300/25 bg-cyan-300/10 font-display text-sm font-bold text-cyan-100">
          <IconRenderer value={selected.value} iconSet={iconSet} />
        </span>
        <select
          className="h-11 w-full rounded-md border border-cyan-300/20 bg-black/30 px-3 text-sm text-white outline-none transition focus:border-cyan-300"
          value={value}
          onChange={(event) => onChange(event.target.value)}
        >
          {options.map((option) => (
            <option key={option.value || "none"} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </label>
  );
}
